import SvgIcon from '@elementor/ui/SvgIcon';

export const WordPressLogoIcon = () => (
	<SvgIcon width="24" height="24" fill="none" viewBox="0 0 24 24">
		<path
			fill="#fff"
			d="M1.703 12c0 4.075 2.371 7.594 5.803 9.264L2.596 7.81A10.25 10.25 0 0 0 1.703 12M18.946 11.477c0-1.272-.456-2.155-.85-2.842-.523-.85-1.013-1.565-1.013-2.414 0-.946.72-1.829 1.728-1.829.048 0 .091.005.13.005a10.28 10.28 0 0 0-6.946-2.698 10.28 10.28 0 0 0-8.597 4.642c.24.005.47.014.658.014 1.075 0 2.74-.13 2.74-.13.558-.033.62.783.068.85 0 0-.557.067-1.176.096l3.749 11.15 2.256-6.753-1.608-4.392C9.528 7.142 9.01 7.08 9.01 7.08c-.557-.034-.49-.883.067-.85 0 0 1.699.13 2.707.13 1.075 0 2.74-.13 2.74-.13.558-.033.62.783.068.85 0 0-.562.067-1.176.096l3.72 11.064 1.027-3.427c.442-1.43.783-2.453.783-3.336"
		/>
		<path
			fill="#fff"
			d="m12.182 12.902-3.086 8.972c.921.268 1.9.417 2.904.417 1.2 0 2.352-.211 3.422-.58-.024-.049-.053-.092-.072-.145zM21.03 7.066q.07.488.071 1.056c0 1.046-.197 2.217-.782 3.686l-3.15 9.087a10.28 10.28 0 0 0 5.118-8.9c.01-1.785-.456-3.47-1.258-4.93"
		/>
		<path
			fill="#fff"
			d="M12 0C5.386 0 0 5.386 0 12s5.38 12 12 12c6.614 0 12-5.386 12-12S18.614 0 12 0m0 23.453C5.688 23.453.547 18.317.547 12S5.688.547 12 .547 23.453 5.683 23.453 12c-.01 6.312-5.141 11.453-11.453 11.453"
		/>
	</SvgIcon>
);
